import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../api/auth';
import { apiFetchWithMeta } from '../api/client';
import { DataTable, PageHeader } from '../components/DesignSystem';
import { formatDate } from '../lib/format';

interface AuditEntry {
  id: string;
  action: string;
  entityType: string;
  actorEmail: string | null;
  createdAt: string;
}
export function SystemAuditPage() {
  const { token } = useAuth();
  const [page, setPage] = useState(1);
  const events = useQuery({
    queryKey: ['audit', page],
    queryFn: ({ signal }) =>
      apiFetchWithMeta<AuditEntry[]>(`/audit?page=${page}&limit=25`, { token, signal }),
    enabled: token !== null,
  });
  return (
    <>
      <PageHeader title="System Audit" caption="Recorded changes within your workspace." />
      <section className="rfp-card">
        {events.isLoading ? (
          <p role="status">Loading audit events…</p>
        ) : events.isError ? (
          <p role="alert">Audit events are unavailable. Your account needs audit access.</p>
        ) : (
          <DataTable
            columns={[
              { key: 'createdAt', header: 'Date', render: (row) => formatDate(row.createdAt) },
              { key: 'action', header: 'Action' },
              { key: 'entityType', header: 'Record type' },
              { key: 'actorEmail', header: 'Changed by' },
            ]}
            rows={events.data?.data ?? []}
            rowKey={(row) => row.id}
            emptyMessage="No recorded changes yet."
          />
        )}
        <div className="rfp-toolbar">
          <button type="button" disabled={page === 1} onClick={() => setPage(page - 1)}>
            Previous page
          </button>
          <span>Page {page}</span>
          <button
            type="button"
            disabled={
              !events.data || page * 25 >= (events.data.meta?.total ?? events.data.data.length)
            }
            onClick={() => setPage(page + 1)}
          >
            Next page
          </button>
        </div>
      </section>
    </>
  );
}
